import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { ContentClient } from "../content/content.client";
import { ContentGroupType, ImageContent } from "../content/content.model";

/**
 * @deprecated [fabric-deprecated] - Use fabric ImageService from svc-content instead
 */
@Injectable({
	providedIn: "root",
})
export class ImageService {
	constructor(private client: ContentClient) {}

	/**
	 * @deprecated [fabric-deprecated] - Use fabric ImageService from svc-content instead
	 */
	getAll(group: ContentGroupType): Observable<Record<string, ImageContent>> {
		return this.client.getImages(group);
	}
}
